import { Observable } from 'rxjs/Observable';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { filter } from 'rxjs/operators/filter';
import { map } from 'rxjs/operators/map';
import { pluck } from 'rxjs/operators/pluck';
import { shareReplay } from 'rxjs/operators/shareReplay';
import { wchBoxLayoutMode, DEFAULT_FETCH_LEVELS } from './../wch/wch.utils';

import { JsonMap } from '../json/json.utils';
import { RenderingContext, SitePage } from './../../api';
import { toInteger, deepEquals } from './../js/js.utils';
import { isArrayOf, isBoolean, isNotNil, isNumber, isPlainObject, IsPredicate, isString } from './../predicates/predicates';
import { pageArrayEquals, pageEquals, pageFromRenderingContext } from './../site/site.utils';

/* Copyright IBM Corp. 2018 */
export const deepDistinctUntilChanged = <T>() => distinctUntilChanged<T>(deepEquals);
export const pageDistinctUntilChanged = () => distinctUntilChanged<SitePage>(pageEquals);
export const pageArrayDistinctUntilChanged = () => distinctUntilChanged<SitePage[]>(pageArrayEquals);
export const shareLast = <T>() => shareReplay<T>(1);
export const filterNotNil = <T>() => filter<T>(isNotNil);
export const typedPluck = <T, K extends keyof T>(aKey: K) => pluck<T, T[K]>(aKey);

// special filter operators
export const filterString = () => filter<string>(isString);
export const filterBoolean = () => filter<boolean>(isBoolean);
export const filterNumber = () => filter<number>(isNumber);
export const filterObject = () => filter<JsonMap>(isPlainObject);
export const filterArrayOf = <T>(aPredicate: IsPredicate<T>) => filter<T[]>(obj => isArrayOf(obj, aPredicate));

// extracts the origin of the API URL from the rendering context
export const pluckApiOrigin = () => pluck<RenderingContext, string>('context', 'hub', 'apiUrl', 'origin');

// extracts the origin of the Delivery URL from the rendering context
export const pluckDeliveryOrigin = () => pluck<RenderingContext, string>('context', 'hub', 'deliveryUrl', 'origin');

// extracts the current page
export const pluckCurrentPage = () => map<RenderingContext, SitePage>(pageFromRenderingContext);

/**
 * Converts the levels to a valid number value
 */
export const opLevels = map<string | number | null | undefined, number>(aValue => toInteger(aValue, DEFAULT_FETCH_LEVELS));

/**
* Operator to box the layout mode
*/
export const opBoxLayoutMode = map<string, string>(wchBoxLayoutMode);
